/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Statement_PlInputs */

const en_statement_taxonomy_editor_statement_pl = /** @type {(inputs: Statement_Taxonomy_Editor_Statement_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profit & loss`)
};

const nl_statement_taxonomy_editor_statement_pl = /** @type {(inputs: Statement_Taxonomy_Editor_Statement_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winst- en verliesrekening`)
};

/**
* | output |
* | --- |
* | "Profit & loss" |
*
* @param {Statement_Taxonomy_Editor_Statement_PlInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_statement_pl = /** @type {((inputs?: Statement_Taxonomy_Editor_Statement_PlInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Statement_PlInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_statement_pl(inputs)
	return en_statement_taxonomy_editor_statement_pl(inputs)
});